/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Template_PlaceholderInputs */

const en_cas_template_placeholder = /** @type {(inputs: Cas_Template_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a template`)
};

/**
* | output |
* | --- |
* | "Choose a template" |
*
* @param {Cas_Template_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_template_placeholder = /** @type {((inputs?: Cas_Template_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Template_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_template_placeholder(inputs)
});